<template>
  <div class="home">
    <div class="header">
      <headerShow @changeLanguage="changeLanguageFN"></headerShow>
    </div>
    <div class="homeBody reportCards specialNewsList">
      <List style="margin-left:50px;margin-right:50px;">
        <ListItem @click.native="goToPageFN(item.id)" v-for="(item,index) in titleList" :key="index">
          <ListItemMeta :title="item.title" :description="item.description" />
        </ListItem>
      </List>
      <div class="resultPage">
        <Page :current="currentPage" :total="titleTotal" @on-change="changePageFN" size="small" show-total />
      </div>
    </div>
    <footerView></footerView>
  </div>
</template>

<script>
import headerShow from '@/components/headerShow.vue'
import footerView from '@/components/footer.vue'
import { newsRequest } from '../request/request'
export default {
  name: 'home',
  components: {
    headerShow, footerView
  },
  data () {
    return {
      languageVal: 'ch',
      totalPageNum: 0,
      titleList: [],
      titleTotal: 0,
      current: 1,
      isPC: false,
      screenMargin: 50,
      currentPage: 1
    }
  },
  computed: {
  },
  mounted () {
    this.languageVal = localStorage.getItem('language') === 'en' ? 'en' : 'ch'
  },
  created () {
    this.$nextTick(() => {
      this.initFN()
      document.scrollingElement.scrollTop = 0
    })
  },
  watch: {
    '$route' (to, from) {
      this.initFN()
    }
  },
  methods: {
    async newsRequestFN (e) {
      var res = await newsRequest(e)
      if (res.data.code === 0) {
        this.titleList = res.data.data.news
        this.titleTotal = res.data.data.totalNumber
      }
    },

    changeLanguageFN (e) {
      this.languageVal = e === 'en' ? 'en' : 'ch'
      localStorage.language = this.languageVal
      this.newsRequestFN({ pageNum: this.current, size: 10, lang: this.languageVal })
    },

    initFN () {
      if (document.body.clientWidth > 700) {
        this.isPC = true
        this.screenMargin = 200
      }
      this.currentPage = parseInt(localStorage.newsListPage)
      this.newsRequestFN({ pageNum: localStorage.newsListPage, size: 10, lang: this.languageVal })
    },

    changePageFN (e) {
      this.current = e
      localStorage.newsListPage = e
      this.newsRequestFN({ pageNum: e, size: 10, lang: this.languageVal })
    },

    goToPageFN (e) {
      this.$router.push({
        path: '/newsDetail',
        name: 'newsDetail',
        query: {
          id: e

        }
      })
    }
  }
}
</script>
<style lang="scss">
.specialNewsList{
    .ivu-list{
        margin: 0 150px !important;
    }
}
.cardListClass{
    width:40%;
    margin-bottom: 20px;
    height: 30vh;
}
.reportCardList{
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
}
.cardContent{
    width: 100%;
    height: 20vh;
    @include centerLine
}
.cardImg{
    @include containbackground;
    width: 30%;
    height:100%;

    // background-position-y: 0;
    // background-image:  url('../assets/3.png');
}
.cardValue{
    @include bottomLine;
    margin-top: 20px;
    cursor: pointer;
}
.cardValue:hover{
    color:#40A0F0;
}
.cardTxt{
    width: 60%;
    height:100%
}
.cardTitle{
    color:#40A0F0;
    font-size: 22px;
}

</style>
